<template>
  <div id="app">
    <!--<router-view/>-->
    <transition name="fade-left">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive&&iWidth!=null" :class="iWidth>750?'router-view-750':'router-view'">
        </router-view>
      </keep-alive>
    </transition>
    <transition name="fade-left">
      <router-view v-if="!$route.meta.keepAlive&&iWidth!=null" :class="iWidth>750?'router-view-750':'router-view'">
      </router-view>
    </transition>
  </div>
</template>
<script>
import { getToken, getPc, configApi } from "@/utils/common";
import config from "@/utils/config";
import router from "@/router/index";
export default {
  name: "App",
  data() {
    return {
      iWidth: null,
    };
  },
  created() {
    configApi(
      function (res) { },
      function (err) { }
    );
  },
  mounted() {
    // 获取一下url，如果是哈希就强转成history，去掉井号
    var url = window.location.href;
    if (url.indexOf("/#/") != -1) {
      url = url.replace("/#/", "/");
      window.location.href = url;
    }
    var iWidth = document.documentElement.clientWidth;
    // 也就是如果>750,就居中，宽度750，其他情况就100%，保持原来的
    this.iWidth = iWidth;
    var myWidth = document.documentElement.clientWidth;
    config.MyWidth = myWidth;
    if (document.documentElement.clientWidth > 750) myWidth = 750;
    document.getElementsByTagName("html")[0].style.fontSize =
      myWidth / 10 + "px";
    let vid = this.$route.query.vid;
    if (vid) {
      config.Vid = vid;
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.router-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
}
.router-view-750 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 750px;
  height: 100%;
  margin: auto;
  transition: all 0.5s cubic-bezier(0.5, 0, 0.1, 1);
}

.fade-left-enter,
.fade-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.fade-left-leave-active,
.fade-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue